import React, { useState, useEffect } from "react";
import PageLayout from "components/layout/PageLayout";
import { useTranslation } from "react-i18next";
import SettingsCard from "components/commons/SettingsCard";
import SuccessMessage from "components/commons/SuccessMessage";
import { useGetHrSettingsQuery, useSetHrSettingsMutation } from "./api/hrSettingsApiSlice";

export default function HrSettings() {
    const [t] = useTranslation(["global", "absenceReport"]);

    const [settings, setSettings] = useState();
    const [statusMessage, setStatusMessage] = useState("");

    const {
        data,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetHrSettingsQuery();

    const [saveSettings, {
        isLoading: saveIsLoading,
        isSuccess: saveIsSuccess,
        isError: saveIsError,
        error: saveError,
        reset: resetSaveStatus
    }] = useSetHrSettingsMutation();

    useEffect(() => {
        if (data && isSuccess) {
            setSettings(data);
        }
    }, [data, isSuccess]);

    const handleChange = (key, value) => {
        setSettings((prevSettings) => ({
            ...prevSettings,
            [key]: value,
        }));
        resetSaveStatus();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        saveSettings(settings);
    };

    const content = (
        <div>
            {isError ? (
                <p>{t("Failed to load settings.")} {error?.data?.message || error?.status}</p>
            ) : isSuccess && settings ? (
                <form onSubmit={handleSubmit}>
                    {saveIsSuccess && <SuccessMessage />}
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 mb-4">
                        <div className="col">
                            <SettingsCard
                                label={t("absenceReport:setting.min_days_notice_for_requests.title")}
                                description={t("absenceReport:setting.min_days_notice_for_requests.desc")}
                                logo={<i className="fa-regular fa-calendar-days"></i>}
                                value={settings.min_days_notice_for_requests}
                                measureUnit={t("unit.days_other")}
                                onChange={(e) => handleChange("min_days_notice_for_requests", parseInt(e.target.value, 10))}
                                inputType="number"
                            />
                        </div>
                        <div className="col">
                            <SettingsCard
                                label={t("absenceReport:setting.days_for_auto_approval.title")}
                                description={t("absenceReport:setting.days_for_auto_approval.desc")}
                                logo={<i className="fa-solid fa-person-circle-check"></i>}
                                value={settings.days_for_auto_approval}
                                measureUnit={t("unit.days_other")}
                                onChange={(e) => handleChange("days_for_auto_approval", parseInt(e.target.value, 10))}
                                inputType="number"
                            />
                        </div>
                        <div className="col">
                            <SettingsCard
                                label={t("absenceReport:setting.send_monthly_reports.title")}
                                description={t("absenceReport:setting.send_monthly_reports.desc")}
                                logo={<i className="fa-solid fa-envelope-open-text"></i>}
                                value={settings.hr_report_recipients}
                                onChange={(e) => handleChange("hr_report_recipients", e.target.value)}
                                inputType="text"
                            />
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary"><i className="fa-solid fa-floppy-disk"></i> {t("action.save")}</button>


                </form>
            ) : <></>}
        </div>
    );

    return (
        <PageLayout
            pageTitle={t("HR Settings")}
            bodyContent={content}
            onPageRefresh={refetch}
            isLoadingContent={saveIsLoading || isFetching}
            isLoadingPage={isLoading}
            isError={saveIsError || isError}
            errorMsg={saveError || error}
        />
    );
}
